import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';


const RadioButtonGroup = ({ header, value, labels, handleChange, className }) => {
    const { t } = useTranslation('common');

    return (
        <FormControl sx={{width:"100%"}}>
            <FormLabel id="demo-controlled-radio-buttons-group">{header}</FormLabel>
            <RadioGroup
                row
                aria-label="radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={value}
                onChange={handleChange}
                className={className}
            >
                {labels.map((item) => {
                    return <FormControlLabel className={value === item ? 'radio-checked' : 'radio-not-checked'} key={item} value={item} control={<Radio />} label={t(item)} />

                })}
            </RadioGroup>
        </FormControl>
    );
}

RadioButtonGroup.defaultProps = {
    className: {}
  };

RadioButtonGroup.propTypes = {
    header: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    handleChange: PropTypes.func.isRequired,
    className: PropTypes.object
}

export default RadioButtonGroup;